export default "__VITE_ASSET__DeWsV5oh__"